<template>
  <div class="not-found-container">
    <div class="error-content">
      <!-- Código de Error -->
      <div class="error-code">
        <span class="number">4</span>
        <div class="zero-wrapper">
          <i class="ri-compass-line rotating-icon"></i>
        </div>
        <span class="number">4</span>
      </div>

      <!-- Mensaje Principal -->
      <h1 class="error-title">Página no encontrada</h1>
      <p class="error-description">
        Lo sentimos, la página que buscas no existe o ha sido movida.
      </p>

      <!-- Acciones -->
      <div class="error-actions">
        <button @click="goHome" class="btn-primary">
          <img src="@/assets/custom-icons/home_2.svg" alt="" class="nav-icon" style="width: 30px" />
          <span>Volver al Inicio</span>
        </button>
        <button @click="goBack" class="btn-secondary">
          <i class="ri-arrow-left-line"></i>
          <span>Volver Atrás</span>
        </button>
      </div>

      <!-- Enlaces Rápidos -->
      <div class="quick-links">
        <p class="quick-links-title">O explora estas páginas:</p>
        <div class="links-grid">
          <router-link :to="{ name: 'programar' }" class="quick-link">
            <i class="ri-calendar-check-line"></i>
            <span>Programar</span>
          </router-link>
          <router-link :to="{ name: 'mis_clases' }" class="quick-link">
            <i class="ri-book-open-line"></i>
            <span>Mis Clases</span>
          </router-link>
          <router-link :to="{ name: 'registro_academico' }" class="quick-link">
            <i class="ri-file-text-line"></i>
            <span>Registro</span>
          </router-link>
          <router-link :to="{ name: 'profile' }" class="quick-link">
            <i class="ri-user-line"></i>
            <span>Perfil</span>
          </router-link>
        </div>
      </div>
    </div>

    <!-- Decoración de fondo -->
    <div class="background-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NotFound',
  components: {
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' });
    },
    goBack() {
      if (window.history.length > 2) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'home' });
      }
    }
  }
}
</script>

<style scoped>
.not-found-container {
  min-height: calc(100vh - 200px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  position: relative;
  overflow: hidden;
}

.error-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 700px;
  width: 100%;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Código de Error */
.error-code {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.error-code .number {
  font-size: 8rem;
  font-weight: 800;
  background: var(--theme-gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
  text-shadow: 0 4px 20px rgba(13, 78, 140, 0.3);
}

.zero-wrapper {
  position: relative;
  width: 8rem;
  height: 8rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rotating-icon {
  font-size: 8rem;
  color: var(--app-primary-blue);
  animation: rotate 8s linear infinite;
  opacity: 0.9;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Mensaje */
.error-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0 0 1rem 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.error-description {
  font-size: 1.125rem;
  color: var(--theme-text-secondary);
  margin: 0 0 2.5rem 0;
  line-height: 1.6;
}

/* Acciones */
.error-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 3rem;
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  outline: none;
}

.btn-primary {
  background: var(--theme-gradient-primary);
  color: white;
  box-shadow: 0 4px 16px rgba(13, 78, 140, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(13, 78, 140, 0.4);
}

.btn-primary:active {
  transform: translateY(0);
}

.btn-secondary {
  background: var(--theme-bg-card);
  color: var(--theme-text-primary);
  border: 1px solid var(--theme-border-color);
  box-shadow: var(--theme-shadow-sm);
}

.btn-secondary:hover {
  background: var(--theme-hover-bg);
  transform: translateY(-2px);
  box-shadow: var(--theme-shadow-md);
}

.btn-secondary:active {
  transform: translateY(0);
}

/* Enlaces Rápidos */
.quick-links {
  margin-top: 3rem;
}

.quick-links-title {
  font-size: 0.9375rem;
  color: var(--theme-text-secondary);
  margin: 0 0 1.5rem 0;
  font-weight: 500;
}

.links-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1rem;
  max-width: 600px;
  margin: 0 auto;
}

.quick-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1.25rem 1rem;
  background: var(--theme-bg-card);
  border: 1px solid var(--theme-border-color);
  border-radius: 12px;
  color: var(--theme-text-primary);
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--theme-shadow-sm);
}

.quick-link:hover {
  transform: translateY(-4px);
  box-shadow: var(--theme-shadow-md);
  background: var(--theme-hover-bg);
  border-color: var(--app-primary-blue);
  color: var(--app-primary-blue);
  text-decoration: none;
}

.quick-link svg {
  font-size: 1.5rem;
  transition: all 0.3s ease;
}

.quick-link:hover svg {
  transform: scale(1.1);
}

.quick-link span {
  font-size: 0.875rem;
  font-weight: 600;
}

/* Decoración de fondo */
.background-decoration {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: var(--theme-gradient-primary);
  opacity: 0.05;
  animation: float 20s ease-in-out infinite;
}

.circle-1 {
  width: 300px;
  height: 300px;
  top: -100px;
  right: -100px;
  animation-duration: 18s;
}

.circle-2 {
  width: 200px;
  height: 200px;
  bottom: -80px;
  left: -80px;
  animation-duration: 22s;
  animation-delay: -5s;
}

.circle-3 {
  width: 150px;
  height: 150px;
  top: 50%;
  left: 10%;
  animation-duration: 25s;
  animation-delay: -10s;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  25% {
    transform: translate(30px, -30px) scale(1.1);
  }
  50% {
    transform: translate(-20px, 20px) scale(0.9);
  }
  75% {
    transform: translate(40px, 10px) scale(1.05);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .not-found-container {
    min-height: calc(100vh - 180px);
    padding: 1.5rem;
  }

  .error-code .number {
    font-size: 5rem;
  }

  .zero-wrapper {
    width: 5rem;
    height: 5rem;
  }

  .rotating-icon {
    font-size: 5rem;
  }

  .error-title {
    font-size: 2rem;
  }

  .error-description {
    font-size: 1rem;
  }

  .error-actions {
    flex-direction: column;
    width: 100%;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    justify-content: center;
  }

  .links-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .error-code .number {
    font-size: 4rem;
  }

  .zero-wrapper {
    width: 4rem;
    height: 4rem;
  }

  .rotating-icon {
    font-size: 4rem;
  }

  .error-title {
    font-size: 1.5rem;
  }

  .error-description {
    font-size: 0.9375rem;
  }

  .circle-1 {
    width: 200px;
    height: 200px;
  }

  .circle-2 {
    width: 150px;
    height: 150px;
  }

  .circle-3 {
    width: 100px;
    height: 100px;
  }
}
</style>
